export function loadImage(sourceImage: string|HTMLImageElement): Promise<HTMLImageElement> {
    return new Promise((resolve, reject) => {
        let img: HTMLImageElement;

        if (typeof sourceImage === "string") {
            img = new Image();
            img.src = sourceImage as string;
        } else {
            img = sourceImage as HTMLImageElement;
        }
        if (img.complete) {
            resolve(img);
        } else {
            img.onload = () => {
                resolve(img);
            };
            img.onerror = () => {
                reject("Cannot load image.");
            };
        }
    });
}



/** WEBPACK FOOTER **
 ** ./build/js/~/tslint-loader!./source/cdn/document_root/s/diy/image-inline-editor/loadImage.ts
 **/